
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../common/services/common-data.service';
import { GraphqlService } from '../common/services/graphql.service';
import { LoginService } from '../common/services/Login.service';
import { OpenLinkById } from '../common/services/openlinkbyid';
import { SessionService } from '../common/services/Session.service';

@Component({
  selector: 'app-taxonomyelementreffile',
  templateUrl: './taxonomyelementreffile.component.html'
})
export class TaxonomyelementreffileComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private sanitizer: DomSanitizer, private route: Router, private openlinkid: OpenLinkById, private session: SessionService, private loginService: LoginService) {
   
  }
  outcome = false;
  tereffile_header;
  tereffile_content;
  tereffile_link;
  role: any;
  userId: any;
  Isnotloginpage = true;
  s3bucketbasepath;

  @Output() myEvent = new EventEmitter<string>();
  ngOnInit(): void {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.userId = data.user.firstname + " " + data.user.lastname;
        this.role = data.user.roles;
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.userId = this.session.userInfo.user.firstname + " " + this.session.userInfo.user.lastname;
      this.role = this.session.userInfo.user.roles;
    }
    if (this.route.url == '/Login') {
      this.Isnotloginpage = false;
    }
    window.scrollTo(0, 0);
    this.graphQlService.getS3BucketSitesImagePath().subscribe(data => {
      this.s3bucketbasepath = data;
    });
    this.commonDataService.showLoader.next(true);
    this.getTaxonomyElementRefFileLabels();
  }

  openLinkById(event) {
    event.preventDefault();
    let id = event.target.getAttribute('id');
    if ((id.includes('.')) && (id.split('.').pop() === 'csv')) {

      let url = `${this.s3bucketbasepath}/${id}`;
      window.open(url, "_blank");

    }
  }

  onRightClick(event) {
    let id = event.target.id;
    if (id != "") {
      event.target.href = this.s3bucketbasepath + "/" + event.target.id;
    }
  }
  getTaxonomyElementRefFileLabels() {

    this.graphQlService.getTaxonomyElementRefFileLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.tereffile_header = labels.filter(x => x.key == "tereffile_header").map(y => y.value);
        this.tereffile_content = labels.filter(x => x.key == "tereffile_content").map(y => y.value);
        this.tereffile_link = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "tereffile_link").map(y => y.value));
        this.outcome = true;
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
}

